import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-3ff6eebc"), n = n(), _popScopeId(), n);
const _hoisted_1 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h3", {
  class: "success__top-title"
}, "Информация о доставке", -1));
const _hoisted_2 = {
  class: "success__list"
};
const _hoisted_3 = {
  class: "success__list-item"
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "success__list-name"
}, "Адрес:", -1));
const _hoisted_5 = {
  class: "success__list-value"
};
const _hoisted_6 = {
  class: "success__list-item"
};
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "success__list-name"
}, "Время:", -1));
const _hoisted_8 = {
  class: "success__list-value"
};
const _hoisted_9 = {
  class: "success__list-item"
};
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "success__list-name"
}, "Способ оплаты:", -1));
const _hoisted_11 = {
  class: "success__list-value"
};
const _hoisted_12 = {
  class: "success__list-item"
};
const _hoisted_13 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "success__list-name"
}, "Сумма к оплате:", -1));
const _hoisted_14 = {
  class: "success__list-value"
};
const _hoisted_15 = {
  key: 0,
  class: "success__list-item"
};
const _hoisted_16 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "success__list-name"
}, "Сдача с", -1));
const _hoisted_17 = {
  class: "success__list-value"
};
const _hoisted_18 = {
  key: 1,
  class: "success__list-item"
};
const _hoisted_19 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "success__list-name"
}, "Кол-во человек:", -1));
const _hoisted_20 = {
  class: "success__list-value"
};
const _hoisted_21 = {
  key: 0,
  class: "success__options"
};
const _hoisted_22 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "success__options-title"
}, "Примечание:", -1));
const _hoisted_23 = {
  class: "success__options-text"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", null, [_hoisted_1, _createElementVNode("ul", _hoisted_2, [_createElementVNode("li", _hoisted_3, [_hoisted_4, _createElementVNode("p", _hoisted_5, _toDisplayString($props.address) + _toDisplayString($props.input ? ", подъезд " + $props.input : "") + _toDisplayString($props.apartment ? ", кв " + $props.apartment : "") + _toDisplayString($props.floor ? ", этаж " + $props.floor : ""), 1)]), _createElementVNode("li", _hoisted_6, [_hoisted_7, _createElementVNode("p", _hoisted_8, _toDisplayString($props.formattedDate[0]) + " " + _toDisplayString($props.formattedDate[1]), 1)]), _createElementVNode("li", _hoisted_9, [_hoisted_10, _createElementVNode("p", _hoisted_11, _toDisplayString($props.payment), 1)]), _createElementVNode("li", _hoisted_12, [_hoisted_13, _createElementVNode("p", _hoisted_14, _toDisplayString($props.totalPrice) + " грн", 1)]), Number.isInteger($props.change) ? (_openBlock(), _createElementBlock("li", _hoisted_15, [_hoisted_16, _createElementVNode("p", _hoisted_17, _toDisplayString($props.change) + " грн", 1)])) : _createCommentVNode("", true), $props.regularSticks ? (_openBlock(), _createElementBlock("li", _hoisted_18, [_hoisted_19, _createElementVNode("p", _hoisted_20, _toDisplayString($props.regularSticks), 1)])) : _createCommentVNode("", true)]), $props.note || $data.formattedOptions ? (_openBlock(), _createElementBlock("div", _hoisted_21, [_hoisted_22, _createElementVNode("p", _hoisted_23, _toDisplayString($props.note ? $props.note + ". " : "") + _toDisplayString($data.formattedOptions), 1)])) : _createCommentVNode("", true)]);
}